import { render, staticRenderFns } from "./FormatArchiveSelector.vue?vue&type=template&id=1ccb4014&scoped=true&"
import script from "./FormatArchiveSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatArchiveSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatArchiveSelector.vue?vue&type=style&index=0&id=1ccb4014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb4014",
  null
  
)

export default component.exports